
export enum RolloverRecommendationAction {
  MoveOn = 'Move On',
  AddSkillTutoring = 'Add skill tutoring',
  RecommendPrerequisite = 'Recommend Prerequisite skill for this student',
  TeacherInstruction = 'Teacher instruction',
  CompleteAssignments = 'Complete assignments',
  NoAction = 'No action',
}